import ChatAvatar from './Avatar';

export default ChatAvatar;
